export enum PARAMS {
   ID = "id",
   CONSULTANT = "consultant"
}

export enum SESSION_STORAGE {
   CONSULTANTUUID = "consultantUuid"
}